import Header from 'src/components/molecules/header'
import Sidebar from 'src/components/organisms/sidebar'
import LoadingOverlay from 'src/components/molecules/loading-overlay'

import { useLoadingStore } from 'src/stores'
import { useTranslation } from 'react-i18next'
import { useLocation } from 'react-router-dom'
import { Layout, theme, Spin, Result } from 'antd'
import { useState, useEffect, useRef } from 'react'
import { useRoutePermissions } from 'src/utils/route-permissions'
import { useInactivityTimeout } from 'src/hooks/use-inactivity-logout'

type Props = {
  contentId?: string
  children: React.ReactNode
}

function MainLayout({ children, contentId }: Props) {
  const { t } = useTranslation()
  const { isLoading } = useLoadingStore()
  const { hasAccessToRoute } = useRoutePermissions()
  const {
    token: { colorBgBase },
  } = theme.useToken()

  const [loading, setLoading] = useState(true)

  const location = useLocation()
  const contentRef = useRef<HTMLDivElement>(null)

  const handleLogout = () => {
    localStorage.clear()
    window.location.href = '/login'
  }
  useEffect(() => {
    if (contentRef.current) {
      contentRef.current.scrollTop = 0
    }
  }, [location.pathname])

  useEffect(() => {
    const timer = setTimeout(() => {
      setLoading(false)
    }, 1000)
    return () => clearTimeout(timer)
  }, [])

  const hasAccess = hasAccessToRoute(location.pathname)

  const noPaddingTopRoutes = [
    '/tools-reports/open-invoices',
    '/tools-reports/purchase-orders',
  ]
  const isNoPaddingTop = noPaddingTopRoutes.some((route) =>
    location.pathname.startsWith(route)
  )

  useInactivityTimeout(handleLogout)

  return (
    <Layout className="h-full min-h-screen">
      <Sidebar />

      <Layout style={{ background: colorBgBase }} className="min-h-screen">
        <Header />

        <Layout
          ref={contentRef}
          id={contentId}
          style={{ minHeight: 0 }}
          className={`hover-scrollbar relative flex flex-1 overflow-y-auto overflow-x-hidden px-4 pb-4 pl-6 ${
            isNoPaddingTop ? '' : 'pt-4'
          }`}
        >
          {loading ? (
            <div className="flex h-full items-center justify-center">
              <Spin />
            </div>
          ) : hasAccess ? (
            <>
              <LoadingOverlay open={isLoading} showMessages />
              {children}
            </>
          ) : (
            <Result
              status="403"
              title={t('common.error.403.title')}
              subTitle={t('common.error.403.subTitle')}
            />
          )}
        </Layout>
      </Layout>
    </Layout>
  )
}

export default MainLayout
